<template>
    <div class="checkout-delivery">
        <CheckoutDeliveryUkraine />
    </div>
</template>

<script setup>
import CheckoutDeliveryUkraine from "./CheckoutDeliveryUkraine/CheckoutDeliveryUkraine";

</script>

<script>

export default {
    name: 'CheckoutDelivery',
}
</script>

<style lang="scss" scoped>
.checkout-delivery{

}
</style>